import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent } from '../../../util/responseUtil';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_LOGIN_HISTORY_VIEW } from '../../../constants/menuPermissionConstant';
import API_SETTINGS from '../../../api/apiSettings';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import TableNexcare from '../../../components/Table/TableNexcare';
import DateRange from '../../../components/Common/DateRange';
import DateRange2 from '../../../components/DateRange/DateRange';
import IconRefresh from '../../../assets/icons/IconRefresh';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import Modal from '../../../components/Modal/Modal';

const columnsLoginHistory = [
    {
        title: "ID",
        dataIndex: "id",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "Nama Pengguna",
        dataIndex: "username",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "Waktu Login",
        dataIndex: "login_time",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
    },
    {
        title: "Waktu Logout",
        dataIndex: "logout_time",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
    }
];

class LoginHistory extends Component {
    constructor(props) {
        super(props);

        // Refs
        this.periodDateRangeRef = createRef();

        this.state = {
            loading: true,
            userType: 'nexsoft',
            historyLogin: {
                orderByData: [],
                orderByValue: [],
                keyword: '',
                filter: '',
                reset: false,
                data: []
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            startDate: null,
            endDate: null,
            showErrorAlertResponse: false,
            errorMessage: '',
            csListOptions: [],
            dateFormats: [
                { value: "02/01/2006 03:04 PM", label: "DD/MMM/YYYY HH:MM AM/PM" },
                { value: "02/01/2006 15:04", label: "DD/MMM/YYYY HH:MM" },
                { value: "01/02/2006 03:04 PM", label: "MMM/DD/YYYY HH:MM AM/PM" },
                { value: "01/02/2006 15:04", label: "MMM/DD/YYYY HH:MM" },
                { value: "02-01-2006 03:04 PM", label: "DD-MMM-YYYY HH:MM AM/PM" },
                { value: "02-01-2006 15:04", label: "DD-MMM-YYYY HH:MM" },
                { value: "01-02-2006 03:04 PM", label: "MMM-DD-YYYY HH:MM AM/PM" },
                { value: "01-02-2006 15:04", label: "MMM-DD-YYYY HH:MM" },
                { value: "02/01/2006", label: "DD/MMM/YYYY" },
                { value: "01/02/2006", label: "MMM/DD/YYYY" },
                { value: "02-01-2006", label: "DD-MMM-YYYY" },
                { value: "01-02-2006", label: "MMM-DD-YYYY" },
            ],
            isModalExportHistoryOpen: false,
            isPeriodOpen: false, 
            isExporting: false, 
            isExportDisabled: false,
            exportRequest: {
                userIds: [],
                startDate: "",
                endDate: "",
                dateFormat: { value: "02/01/2006 03:04 PM", label: "DD/MMM/YYYY HH:MM AM/PM" }
            }
        }
    }

    getInitiateHistoryLogin = () => {
        API_SETTINGS.getInitiateHistoryLogin(this.state.userType, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let validOrderBy = getContent(res).valid_order_by.map(orderBy => ({
                        value: orderBy,
                        label: orderBy
                    }))
                    this.setState({
                        historyLogin: {
                            ...this.state.historyLogin,
                            orderByData: validOrderBy
                        },
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getHistoryLogin = () => {
        let order = this.state.historyLogin.orderByValue.length !== 0 ? this.state.historyLogin.orderByValue.value : 'log_login_history.id desc';
        if (order === 'log_login_history.id') order = `${order} desc`;

        API_SETTINGS.getHistoryLogin(this.state.pagination.current, this.state.pagination.pageSize, order, this.state.userType, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        historyLogin: {
                            ...this.state.historyLogin,
                            data: getContent(res),
                            reset: false
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({ loading: false });
            }))
    }

    getInitiateSearchHistoryLogin = () => {
        API_SETTINGS.getInitiateSearchHistoryLogin(this.state.userType, this.state.historyLogin.filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let validOrderBy = getContent(res).valid_order_by.map(orderBy => ({
                        value: orderBy,
                        label: orderBy
                    }))
                    this.setState({
                        historyLogin: {
                            ...this.state.historyLogin,
                            orderByData: validOrderBy
                        },
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchHistoryLogin = () => {
        let order = this.state.historyLogin.orderByValue.length !== 0 ? this.state.historyLogin.orderByValue.value : 'log_login_history.id desc';
        if (order === 'log_login_history.id') order = `${order} desc`;

        API_SETTINGS.getSearchHistoryLogin(this.state.pagination.current, this.state.pagination.pageSize, order, this.state.userType, this.state.historyLogin.filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        historyLogin: {
                            ...this.state.historyLogin,
                            data: getContent(res),
                            reset: false
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({ loading: false });
            }))
    }

    getCSList = async () => {
        try {
            const res = await API_SETTINGS.getListUserCustomerServiceLoginHistory(1, 100, true, this.props.token)
            const csList = res.data.nexsoft.payload.data.content ? res.data.nexsoft.payload.data.content : []

            if (this._isMounted) {
                this.setState({
                    csListOptions: csList.map(cs => ({
                        label: cs.name,
                        value: cs.user_nexcare_id
                    }))
                })
            }
        } catch(err) {
            const errHandler = errorHandler(this.props.handleLogout, this.props.history, () => {
                this.setState({ loading: false });
            })
            errHandler(err)
        }
    }

    handleChangeUserType = async userType => {
        await this.setState({
            loading: true,
            userType
        });

        this.handleResetSearch();
    }

    handleChangeUsername = e => {
        this.setState({
            historyLogin: {
                ...this.state.historyLogin,
                keyword: e.target.value
            }
        })
    }

    handleDateRange = update => {
        this.setState({ startDate: update[0], endDate: update[1] })
    }

    handleChangeOrderBy = data => {
        this.setState({
            historyLogin: {
                ...this.state.historyLogin,
                orderByValue: data
            }
        })
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                if (this.state.historyLogin.orderByValue.length !== 0 || this.state.historyLogin.filter !== '') {
                    return this.getSearchHistoryLogin();
                }
                this.getHistoryLogin();
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                if (this.state.historyLogin.orderByValue.length !== 0 || this.state.historyLogin.filter !== '') {
                    return this.getSearchHistoryLogin();
                }
                this.getHistoryLogin();
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                loading: true,
                filter: sorter
            },
            () => {
                console.log(this.state.filter, "Hit API get data table");
            }
        );
    }

    handleResetSearch = async () => {
        await this.setState({
            loading: true,
            historyLogin: {
                ...this.state.historyLogin,
                keyword: '',
                filter: '',
                orderByValue: [],
                reset: true
            },
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
                total: 0
            },
            startDate: null,
            endDate: null
        })

        this.getInitiateHistoryLogin();
        this.getHistoryLogin();
    }

    handleSearch = async () => {
        let startDate = this.state.startDate === null ? '' : moment(this.state.startDate).format('YYYY-MM-DD');
        let endDate = this.state.endDate === null ? '' : moment(this.state.endDate).format('YYYY-MM-DD');

        let filterHistoryLogin = `&filter=username like ${this.state.historyLogin.keyword}&start_date=${startDate}&end_date=${endDate}`

        await this.setState({
            loading: true,
            historyLogin: {
                ...this.state.historyLogin,
                filter: filterHistoryLogin
            },
            pagination: {
                ...this.state.pagination,
                current: 1
            }
        })

        this.getInitiateSearchHistoryLogin();
        this.getSearchHistoryLogin();
    }

    componentDidMount() {
        this._isMounted = true;

        // Event Listeners
        this.handlePeriodDateRangeClickEvent();
        this.handleModalKeyDownEvent();

        this.getInitiateHistoryLogin();
        this.getHistoryLogin();
        this.getCSList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // Used to close the period date range when clicked outside of it.
    handlePeriodDateRangeClickEvent = () => {
        if (!this.periodDateRangeRef.current) {
            return
        }

        document.addEventListener('click', e => {
            if (!this.periodDateRangeRef.current.contains(e.target)) {
                this.setState({
                    isPeriodOpen: false
                })
            }
        })
    }

    // Used to close export modal box when Escape key is hit.
    handleModalKeyDownEvent = () => {
        document.addEventListener('keydown', e => {
            if (e.code === "Escape" && this.state.isModalExportHistoryOpen) {
                this.setState({
                    isModalExportHistoryOpen: false
                })
            }
        })
    }

    handleChangeMultiSelectUsers = data => {
        this.setState({
            exportRequest: {
                ...this.state.exportRequest,
                userIds: data
            }
        })
    }

    handlePeriodText = () => {
        const exportRequest = this.state.exportRequest

        if (exportRequest.startDate === "" || exportRequest.endDate === "") {
            return <span className="text-gray-500">Pilih Periode</span>
        }

        return `${moment(exportRequest.startDate).format('DD/MM/YYYY')} - ${moment(exportRequest.endDate).format('DD/MM/YYYY')}`
    }

    handlePeriodChange = (from, thru) => {
        const startDate = new Date(from)
        const endDate = new Date(thru)

        from = `${startDate.getFullYear()}-${this.appendZero(startDate.getUTCMonth() + 1)}-${this.appendZero(startDate.getUTCDate())}`
        thru = `${endDate.getFullYear()}-${this.appendZero(endDate.getUTCMonth() + 1)}-${this.appendZero(endDate.getUTCDate())}`

        this.setState({
            exportRequest: {
                ...this.state.exportRequest,
                startDate: from,
                endDate: thru
            }
        })
    }

    handleResetPeriod = () => {
        this.setState({
            exportRequest: {
                ...this.state.exportRequest,
                startDate: "",
                endDate: ""
            }
        })
    }

    handleSelectDateFormatChange = (data) => {
        this.setState({
            exportRequest: {
                ...this.state.exportRequest,
                dateFormat: data
            }
        })
    }

    handleExport = async () => {
        // Disable export button immediately
        this.setState({
            isExportDisabled: true
        })

        const exportRequest = this.state.exportRequest

        let userIds = []
        let startDate = exportRequest.startDate
        let endDate = exportRequest.endDate
        let dateFormat = exportRequest.dateFormat.value
        
        // Reformat user ids
        exportRequest.userIds.forEach(userId => {
            userIds.push(userId.value)
        })

        // Show spinner on export button
        const spinnerTimeout = setTimeout(() => {
            this.setState({
                isExporting: true
            })  
        }, 250)

        try {
            const res = await API_SETTINGS.exportHistoryLogin(
                userIds.join(","), 
                startDate, 
                endDate, 
                dateFormat, 
                this.props.token
            )

            // Download CSV File
            const blob = new Blob(
                ["\uFEFF" + res.data],
                { type: 'text/csv;charset=utf-8;' }
            );

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = res.headers["x-filename"] ? res.headers["x-filename"] : 'loglogin.csv';
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);
        } catch(err) {
            const errHandler = errorHandler(this.props.handleLogout, this.props.history, () => {
                this.setState({ loading: false });
            })
            errHandler(err)
        } finally {
            // Hide spinner and enable export button.
            clearTimeout(spinnerTimeout)

            this.setState({
                isExporting: false,
                isExportDisabled: false,
                isModalExportHistoryOpen: false
            })
        }
    }

    appendZero = (number) => {
        if (number < 10) {
            return "0" + number
        }

        return number
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_LOGIN_HISTORY_VIEW]} userPermission={this.props.userDetail.permissions}>

                {/* Loader */}
                <LoadingLoader show={this.state.loading} />

                {/* Export Login Histories Modal */}
                <Modal isOpen={this.state.isModalExportHistoryOpen} onOverlayClick={() => this.setState({ isModalExportHistoryOpen: false })} modalBoxStyle={{ width: '600px' }}>
                    <Modal.Title>Export</Modal.Title>
                    <Modal.Body>
                        <div className="mb-5">
                            <label>User</label>
                            <Select
                                id="ddluser"
                                placeholder="Pilih User"
                                closeMenuOnSelect={false}
                                isMulti
                                options={this.state.csListOptions}
                                onChange={this.handleChangeMultiSelectUsers}
                                value={this.state.exportRequest.userIds}
                            />
                        </div>
                        <div className="mb-5">
                            <label>Periode</label>
                            <div className='relative' ref={this.periodDateRangeRef}>
                                <div 
                                    className="form-control select-none" 
                                    id="btnperiodloginhistory" 
                                    onClick={() => this.setState({ isPeriodOpen: !this.state.isPeriodOpen })}  
                                    tabIndex="-1" 
                                >
                                    {this.handlePeriodText()}
                                </div>
                                <div className={`absolute left-0 top-full z-20 text-sm bg-white ${!this.state.isPeriodOpen ? "hidden" : ""}`}>
                                    <DateRange2
                                        from={this.state.exportRequest.startDate ? new Date(this.state.exportRequest.startDate) : undefined}
                                        to={this.state.exportRequest.endDate ? new Date(this.state.exportRequest.endDate) : undefined}
                                        getDateRange={this.handlePeriodChange}
                                        resetDateRange={this.handleResetPeriod}
                                        handleSave={() => this.setState({ isPeriodOpen: !this.state.isPeriodOpen })}
                                        showButton={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label>Format Tanggal</label>
                            <Select
                                id="ddldateformat"
                                placeholder="Pilih format tanggal"
                                options={this.state.dateFormats}
                                value={this.state.exportRequest.dateFormat}
                                onChange={this.handleSelectDateFormatChange}
                            />
                        </div>
                        <div className="flex justify-center items-center">
                            <button 
                                type="button" 
                                id="btncancel" 
                                className="bg-white rounded text-darkblue font-medium border border-lightblue focus:outline-none px-10 py-2 mt-3 mr-2" 
                                onClick={() => this.setState({ 
                                    isModalExportHistoryOpen: false
                                })}>
                                Batal
                            </button>
                            <button 
                                type="button" 
                                id="btnexport" 
                                className={`bg-darkblue rounded text-white font-medium border border-darkblue focus:outline-none px-10 py-2 mt-3 ml-2 transition duration-300 ${this.state.isExportDisabled ? 'cursor-not-allowed' : ''}`}
                                onClick={this.handleExport}
                                disabled={this.state.isExportDisabled}
                            >
                                {
                                    this.state.isExporting 
                                        ? <><FontAwesomeIcon className='mr-2 animate-spin' icon={faCircleNotch} />Exporting...</> 
                                        : 'Export'
                                }
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Main Content */}
                <div className="h-full pb-5">
                    <BreadCrumbs
                        parentMenu="Laporan"
                        serviceMenu="Riwayat Akses"
                        title="Riwayat Akses"
                    />

                    {/* WHITECONTAINER */}
                    <div className="h-content">
                        <div className="w-full h-full bg-white border border-gray-300 rounded-lg p-8 space-y-10">
                            <div className="menu">
                                <span className={
                                    this.state.userType === 'nexsoft'
                                        ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2 mr-7"
                                        : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2 mr-7"
                                }
                                    onClick={() => this.handleChangeUserType('nexsoft')}
                                >CS</span>
                                <span className={
                                    this.state.userType === 'customer'
                                        ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2 mr-7"
                                        : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2 mr-7"
                                }
                                    onClick={() => this.handleChangeUserType('customer')}
                                >Distributor</span>
                                <span className={
                                    this.state.userType === 'principal'
                                        ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                                        : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                                }
                                    onClick={() => this.handleChangeUserType('principal')}
                                >Principal</span>
                            </div>
                            <div className="header flex space-x-3 mb-8">
                                <div className="w-1/4 flex items-center relative">
                                    <input
                                        type="text"
                                        id="tslusername"
                                        className="custom-form-control w-full h-full pl-3 pr-8"
                                        placeholder="Nama Pengguna"
                                        value={this.state.historyLogin.keyword}
                                        onChange={this.handleChangeUsername}
                                        autoComplete="off"
                                    />
                                    <FontAwesomeIcon icon={faSearch} className="absolute right-3 text-gray-500" />
                                </div>
                                <div className="w-1/4">
                                    <DateRange
                                        startDate={this.state.startDate}
                                        endDate={this.state.endDate}
                                        reset={this.state.historyLogin.reset}
                                        handleDateRange={this.handleDateRange}
                                    />
                                </div>
                                <Select
                                    id="ddlorderby"
                                    className="w-1/4"
                                    placeholder="Urutan Data"
                                    options={this.state.historyLogin.orderByData}
                                    value={this.state.historyLogin.orderByValue}
                                    onChange={this.handleChangeOrderBy}
                                />
                                <div className="w-1/4 flex items-center space-x-3">
                                    <button type="button" id="btnreset" className="bg-darkblue text-white text-sm rounded px-3 h-full" onClick={() => this.handleSearch()}>Apply</button>
                                    <button 
                                        type="button" 
                                        id="btnshowexportmodal" 
                                        className="bg-darkblue text-white text-sm rounded px-3 h-full" 
                                        onClick={() => this.setState({ isModalExportHistoryOpen: true })}>
                                            Export
                                    </button>
                                    <div className="bg-lightblue rounded text-white flex justify-center items-center cursor-pointer px-3 h-full" onClick={() => this.handleSearch()}>
                                        <IconRefresh />
                                        <span className="ml-2">Perbaharui</span>
                                    </div>
                                    <p className="text-darkblue cursor-pointer" onClick={this.handleResetSearch}>Reset Filter</p>
                                </div>
                            </div>
                            <div className="body">
                                <TableNexcare
                                    column={columnsLoginHistory}
                                    dataTable={this.state.historyLogin.data}
                                    pagination={this.state.pagination}
                                    onPage={this.handleSelectedPage}
                                    onPageSize={this.handleSelectedPageSize}
                                    onSorter={this.handleSorter}
                                    halfBodyHeight
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginHistory);